import i18n from '@/i18n'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/activity/$type')({
  async loader() {
    await i18n.loadNamespaces('program/activity')
    return {}
  },
})
